import { DemoConfig, getProfileSettings } from './SlasDemoConfigDialog/DemoConfig'

export const getCellLineDisplayLabel = (config: DemoConfig) => {
  return getProfileSettings(config).cellLineDisplayLabel
}

export const getExperimentLabelDisplayLabel = (config: DemoConfig) => {
  return getProfileSettings(config).experimentLabelDisplayLabel
}
